<template>
    <div v-if="isSupported">
        <Button v-if="!copied" type="button" :size="props.size" @click="copy(modelValue)">
            <slot>
                {{ lang('common::common.buttons.copy_to_clipboard.copy') }}
            </slot>
        </Button>
        <Button v-else type="button" :size="props.size" @click="copy(modelValue)">
            <slot name="copied">
                {{ lang('common::common.buttons.copy_to_clipboard.copied') }}
            </slot>
        </Button>
    </div>
</template>

<script setup lang="ts">
import { ComponentSize } from '@src/Common/DataGrid/types';
import { useClipboard } from '@vueuse/core';

defineOptions({
    inheritAttrs: false,
});

const modelValue = defineModel<string | undefined>();

interface Props {
    placeholder?: string | undefined;
    size?: ComponentSize;
    dusk?: string | null;
    valid?: boolean;
    invalid?: boolean;
    required?: boolean;
    disabled?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
    placeholder: undefined,
    size: 'base',
    dusk: null,
    valid: false,
    invalid: false,
});

const { copy, copied, isSupported } = useClipboard({ source: modelValue });
</script>
